import axios from './axios';

function childFromResponse(data) {
  const avatar = data.avatar || data.childAvatar;
  return {
    id: data.PlayerId || data.childId || null,
    memberId: data.MemberId || data.memberId || null,
    name: data.PlayerName || data.childName || null,
    dob: data.PlayerDOB || null,
    gender: data.PlayerGender || null,
    avatar: avatar !== null ? avatar.internal_name || avatar.internalName || null : null,
    grade: data.PlayerGrade || data.childGrade || null,
    isGradeLocked: data.lockedGrade || false,
    isGradeHidden: data.hiddenGrade || false,
    createdAt: data.DateCreated || null,
    updatedAt: data.DateUpdated || null
  };
}

function getAll() {
  return axios
    .get('/api/children/childrenGroups/')
    .then(function(data) {
      return Object.entries(data.children).reduce(function(acc, cur) {
        const [id, child] = cur;
        acc[id] = childFromResponse(child);
        return acc;
      }, {});
    });
}

function create({ name, dob=null, gender=null, grade=null, avatar=null }) {
  return axios
    .post('/api/child', {
      childName: name,
      childDOB: dob,
      childGender: gender,
      childGrade: grade,
      childAvatar: avatar
    })
    .then(data => {
      return childFromResponse(data);
    });
}

function update(childId, { name=null, grade=null, avatar=null, isGradeLocked=null, isGradeHidden=null }) {
  return axios
    .post(`/api/children/update/session/${childId}`, {
      name,
      grade,
      avatar,
      lockedGrade: isGradeLocked,
      hiddenGrade: isGradeHidden
    })
    .then(function(data) {
      return childFromResponse(data);
    });
}

export default {
  getAll,
  create,
  update
}
